import { avatarColors, cn, initials } from '@/lib/utils'

export interface AvatarProps {
  name: string
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  className?: string
  src?: string | null
}

const sizeMap: Record<NonNullable<AvatarProps['size']>, string> = {
  xs: 'h-5 w-5 text-[10px]',
  sm: 'h-7 w-7 text-xs',
  md: 'h-9 w-9 text-sm',
  lg: 'h-12 w-12 text-base',
  xl: 'h-20 w-20 text-2xl',
}

export function Avatar({ name, size = 'md', className, src }: AvatarProps) {
  const { bg, fg } = avatarColors(name)
  if (src) {
    return (
      <img
        src={src}
        alt={name}
        className={cn('rounded-full object-cover', sizeMap[size], className)}
      />
    )
  }
  return (
    <span
      className={cn('rounded-full inline-flex items-center justify-center font-bold', sizeMap[size], className)}
      style={{ backgroundColor: bg, color: fg }}
      aria-label={name}
    >
      {initials(name)}
    </span>
  )
}
